






















































































import { Component } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import { OnboardingURL } from '@/views/Onboarding/helpers';

import TwismLogoIcon from '@/components/icons/TwismLogo.vue';

import { EStatus } from '@/componentsV2/atoms/StatusTag/StatusTag.vue';
import StatusProgram from './Sections/StatusProgram.vue';
import SelectionBox from '@/componentsV2/molecules/Inputs/SelectionBox.vue';
import BillingService from '@/api/BillingService';
import { SmartBusinessSignupData } from '@/models/smart-business-signup';
import BusinessOnboardingModel from '@/views/BusinessOnboarding/BusinessOnboardingModel.vue';
import { DashboardScreen } from '@/api/enums/dashboard-screen.enum';
import { EBusinessRewardsStatus } from '@/models/business';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    FilledButton,
    Typography,
    StatusProgram,
    TwismLogoIcon,
    SelectionBox
  }
})
export default class CoinNetwork extends BusinessOnboardingModel {
  service = new BillingService();

  EStatus = EStatus;

  billingAcceptance = true;
  loading = false;

  loyaltyEnable = this.showLoyaltyCampaign;
  giftEnable = this.showGiftCampaign;

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get smartBusinessSignupData(): SmartBusinessSignupData {
    return this.$store.getters['businessOnboarding/getSmartBusinessSignup'];
  }

  get showOfferCampaign() {
    return this.smartBusinessSignupData.offersRecommendation.enabled;
  }

  get showLoyaltyCampaign() {
    return this.smartBusinessSignupData.loyaltyPercentageRecommendation.enabled;
  }

  get showGiftCampaign() {
    return this.smartBusinessSignupData.giftPercentageRecommendation.enabled;
  }

  get qtdeCards() {
    return [
      true,
      this.showOfferCampaign,
      this.showLoyaltyCampaign,
      this.showGiftCampaign
    ].filter(Boolean).length;
  }

  changedBilling(value: boolean) {
    this.loyaltyEnable = value ? this.showLoyaltyCampaign : false;
    this.giftEnable = value ? this.showGiftCampaign : false;

    segmentIo.track('AI Sign Up | Coin Network Terms Box Clicked', {
      Enabled: value
    });
  }

  changedLoyalty(value: boolean) {
    this.loyaltyEnable = value;

    if (!value && !this.giftEnable) {
      this.billingAcceptance = false;
    }

    segmentIo.track('AI Sign Up | Coin Network Loyalty Toggle', {
      Enabled: value
    });
  }

  changedGift(value: boolean) {
    this.giftEnable = value;

    if (!value && !this.loyaltyEnable) {
      this.billingAcceptance = false;
    }

    segmentIo.track('AI Sign Up | Coin Network Loyalty Toggle', {
      Enabled: value
    });
  }

  setDefaultProps() {
    this.loyaltyEnable = this.showLoyaltyCampaign;
    this.giftEnable = this.showGiftCampaign;
  }

  async onSubmit() {
    try {
      this.loading = true;

      if (this.billingAcceptance) {
        await this.service.acceptTermsSubscription();
        await this.service.activateSubscription();

        if (this.showLoyaltyCampaign && !this.loyaltyEnable) {
          await this.businessService.putRewardsSettingsStatus({
            status: EBusinessRewardsStatus.INACTIVE
          });
        }

        if (this.showGiftCampaign && !this.giftEnable) {
          await this.businessService.updateSellCoins(
            false,
            DashboardScreen.AIFlow
          );
        }

        if (this.loyaltyEnable)
          this.businessService
            .getRewardStatusList()
            .then(({ data: rewardData }) => {
              this.$store.dispatch('business/SET_REWARD_STATUS', rewardData);
            });

        this.billingService
          .getBillingOverviewSubscription()
          .then(({ data: subscription }) => {
            this.$store.dispatch(
              'business/SET_BILLING_SUBSCRIPTION',
              subscription
            );
          });
      } else if (this.loyaltyEnable || this.giftEnable) {
        this.$notification(
          'Please accept the terms for enable the coin network features',
          'error'
        );
        return;
      } else {
        segmentIo.track('AI Sign Up | Coin Network Not Accepted');
      }

      await this.handleUpdateBusiness();

      this.$router.push(OnboardingURL.WELCOME_TWISM);
    } finally {
      this.loading = false;
    }
  }
}
